import { render, staticRenderFns } from "./forgotten-password.vue?vue&type=template&id=8b162cf0&scoped=true&"
import script from "./forgotten-password.vue?vue&type=script&lang=js&"
export * from "./forgotten-password.vue?vue&type=script&lang=js&"
import style0 from "./forgotten-password.vue?vue&type=style&index=0&id=8b162cf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b162cf0",
  null
  
)

export default component.exports